import React from 'react';
import Message from '../../../../components/common/Message';
import Link from '../../../../components/common/link/Link';
import Typography from '@material-ui/core/Typography';

//@ts-ignore
import styles from './TaxProfile.pcss';

export interface TaxProfileQAProps {
    locale?: string;
}
const TaxProfileQA: React.FC<TaxProfileQAProps> = ({locale}) => {
    let answerLink = `https://www.epicgames.com/help/en-US/fortnite-c75/competitive-c95/why-do-i-keep-receiving-a-403-error-message-when-trying-to-take-my-tax-interview-a3931`;

    if (locale) {
        answerLink = `${answerLink}?lang=${locale}`;
    }

    return (
        <div className={styles.section}>
            <Typography className={styles.title} variant="h4">
                <Message code="epic.affiliate.settings.tax.profile.question.title" />
            </Typography>
            <Typography variant="body2" style={{marginBottom: '10px'}}>
                <Message code="epic.affiliate.settings.tax.profile.question.text" />
            </Typography>
            <Link to={answerLink} color="primary" underline="hover">
                {answerLink}
            </Link>
        </div>
    );
};

export default TaxProfileQA;
